<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="12">
          <h3 class="text-center">Edit Coupons <span class="smh"></span></h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="m-1 p-3">
          <form @submit.prevent="editcoupon">
            <b-form-group label="Coupon Title" class="label" label-for="target">
              <b-form-input
                type="text"
                id="title"
                v-model="create.title"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              label="Coupon Target"
              class="label"
              label-for="target"
            >
              <b-form-input
                type="text"
                id="title"
                v-model="create.target"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              label="Coupon Sponsor"
              class="label"
              label-for="target"
            >
              <b-form-input
                type="text"
                id="name"
                v-model="create.sponsor"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              label="Coupon Sponsor email"
              class="label"
              label-for="target"
            >
              <b-form-input
                type="text"
                id="email"
                v-model="create.sponsor_email"
              ></b-form-input>
            </b-form-group>

            <b-overlay :show="uploadingsponsor">
              <template #overlay>
                <div class="text-center">
                  <b-icon-file-image
                    font-scale="3"
                    animation="throb"
                  ></b-icon-file-image>
                  <p>Uploading Image...</p>
                </div>
              </template>
              <b-form-group>
                <b-form-file
                  v-model="create.attachmentlink"
                  ref="file"
                  placeholder="Choose a file or drop it here"
                  drop-placeholder="Drop File here..."
                  @input="handleImage"
                ></b-form-file>
              </b-form-group>
              <img :src="create.sponsor_logo" class="image-attachment"/>
            </b-overlay>

            <b-form-group label="Coupon Type" v-slot="{ ariaDescribedby }">
              <span class="info-span"
                >*Coupon type could be Normal or Extended. In the normal type
                the upgrade of the user is for the normal period as in monthly
                or yearly, while for the extended type, the upgrade of the user
                spans till the deactivation date of the coupon.
              </span>
              <b-form-radio
                v-model="create.type"
                :aria-describedby="ariaDescribedby"
                name="type"
                value="normal"
                >Normal</b-form-radio
              >
              <b-form-radio
                v-model="create.type"
                :aria-describedby="ariaDescribedby"
                name="type"
                value="extended"
                >Extended</b-form-radio
              >
            </b-form-group>

            <b-form-group
              label="Coupon Description"
              label-for="title"
              class="label"
            >
              <b-form-textarea
                type="text"
                id="description"
                v-model="create.description"
              ></b-form-textarea>
            </b-form-group>

            <b-form-group label="Coupon Discount" label-for="markper">
              <b-form-spinbutton
                id="markper"
                v-model="create.discount"
                min="1"
                max="100"
                step="1"
              ></b-form-spinbutton>
            </b-form-group>

            <b-form-group
              disabled
              label="Coupon Code"
              label-for="code"
              class="label"
            >
              <div class="flex-input-parent">
                <div
                  :class="{
                    'left-flex-child': isCheckingcode,
                    'full-width-child': !isCheckingcode
                  }"
                >
                  <b-form-input
                    type="text"
                    id="organization"
                    v-model="create.couponcode"
                    @input="checkCouponcode"
                  ></b-form-input>
                </div>
                <div
                  :class="{
                    'right-flex-child': isCheckingcode,
                    hidden: !isCheckingcode
                  }"
                >
                  <b-icon-x
                    font-scale="2"
                    variant="danger"
                    v-if="couponexists == true"
                  ></b-icon-x>
                  <b-icon-check
                    font-scale="2"
                    variant="success"
                    v-if="couponexists == false"
                  ></b-icon-check>
                </div>
              </div>
              <p class="errtxt" v-if="couponexists == true">
                Coupon code already Exists
              </p>
            </b-form-group>

            <b-form-group>
              <p class="fll">Choose Commence Date</p>
              <b-form-datepicker
                v-model="create.commencement_date"
                :min="new Date()"
                placeholder="Choose a Date"
                required
              ></b-form-datepicker>
            </b-form-group>

            <b-form-group>
              <p class="fll">Choose Deactivate date</p>
              <b-form-datepicker
                v-model="create.deactivate_date"
                :min="new Date()"
                placeholder="Choose a Date"
                required
              ></b-form-datepicker>
            </b-form-group>

            <b-form-group label="Coupon Status" v-slot="{ ariaDescribedby }">
              <b-form-radio
                v-model="create.status"
                :aria-describedby="ariaDescribedby"
                name="status"
                value="active"
                >Active</b-form-radio
              >
              <b-form-radio
                v-model="create.status"
                :aria-describedby="ariaDescribedby"
                name="status"
                value="inactive"
                >Inactive</b-form-radio
              >
            </b-form-group>

            <div v-if="sent" class="alert alert-success p-3">
              Coupon Updated Successfully
            </div>

            <div class="text-center">
              <b-overlay
                :show="sending"
                rounded
                opacity="0.6"
                spinner-small
                spinner-variant="primary"
                class=""
              >
                <div class="mt-4">
                  <b-button
                    :disabled="chkfields"
                    type="submit"
                    variant="outline-success"
                    class="m-lg-3 mt-2 p-2 action-button"
                  >
                    Update Coupon
                  </b-button>
                </div>
              </b-overlay>

              <b-button
                v-if="sending"
                @click="sending = false"
                class="w-50 p-2 mt-3"
                variant="dark"
              >
                Cancel
              </b-button>
            </div>
          </form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  components: {},

  data() {
    return {
      create: this.getForm(),
      sending: false,
      sent: false,
      levels: [0, 1, 2, 3, 4, 5],
      startnum: 0,
      limitnum: this.endss,
      intervalnum: 10,
      endnum: 10,
      btnrange: this.endss,
      pages: 1,
      stockingdata: [
        {
          data: []
        }
      ],
      dataretrieved: false,
      addresponse: "",
      opencreate: false,
      // editor : ClassicEditor,
      // config : config,
      isCheckingcode: false,
      couponexists: false,
      uploadingfile: false,
      uploadedfile: false,
      uploadmessage: "",
      mtype: "",
      filedir: "",
      uploadingsponsor: false,
      attachmentfiles: ""
      // datacount : this.partnershipsarray[0].count
    };
  },
  created() {
    let trackid = this.$route.params.trackid;
    let currentcoupon = this.couponsarray[0].data.filter(
      x => x.trackid == trackid
    )[0];

    this.create = {
      title: currentcoupon.title,
      target: currentcoupon.target,
      description: currentcoupon.description,
      couponcode: currentcoupon.code,
      sponsor: currentcoupon.sponsor,
      sponsor_email: currentcoupon.sponsor_email,
      sponsor_logo: currentcoupon.sponsor_logo,
      commencement_date: currentcoupon.commencement_date,
      deactivate_date: currentcoupon.deactivate_date,
      attachmentlink: "",
      discount: currentcoupon.discount,
      trackid: currentcoupon.trackid,
      admintrackid: currentcoupon.admintrackid,
      status: currentcoupon.status,
      type: currentcoupon.type
    };
  },
  computed: {
    ...mapState({
      users: state => state.admin.allusers,
      details: state => state.loginmaster.details,
      couponsarray: state => state.admin.coupons,
      adminadded: state => state.admin.adminadded,
      environ: state => state.loginmaster.environ,
      origin: state => state.loginmaster.api_origin
    }),
    chkfields() {
      if (
        this.couponexists ||
        this.sending ||
        this.create.title.length <= 0 ||
        this.create.target.length <= 0 ||
        this.create.description.length <= 0 ||
        this.create.couponcode.length <= 0
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions("admin", ["editCoupons", "fetchCoupons", "checkCoupon"]),
    getForm() {
      return {
        discount: 1,
        title: "",
        target: "",
        description: "",
        couponcode: "",
        sponsor: "",
        sponsor_email: "",
        sponsor_logo: "",
        attachmentlink: "",
        commencement_date: "",
        deactivate_date: "",
        status: "active",
        type: "normal",
        admintrackid: "",
        trackid: ""
      };
    },
    handleImage() {
      this.uploadingsponsor = true;
      let ifile = this.$refs.file.files[0];
      this.imageUpload(ifile).then(() => {
        if (this.status == "success") {
          this.uploadingsponsor = false;
          this.$bvModal
            .msgBoxOk(
              "Image Uploaded Successfully. Proceed with Question Upload.",
              {
                title: "Image Uploaded",
                size: "xs",
                centered: true
              }
            )
            .then(() => {});
          this.create.sponsor_logo = this.url;
          console.log(this.url);
          this.create.sponsor_logo = this.url;
          //console.log(response.data);
          this.setFile(this.url);
          this.attachmentfiles = this.url;
        }
      });
    },
    editcoupon() {
      this.sending = true;
      // this.user.organization = this.details.clearance_organization

      return this.editCoupons(this.create).then(() => {
        this.sending = false;
        this.sent = true;

        // this.create.title = ""
        // this.create.description = ""
        // this.create.target = ""
        // this.create.couponcode = ""

        this.fetchCoupons();
      });
    },
    checkCouponcode() {
      this.create.couponcode = this.create.couponcode.toUpperCase();

      if (this.create.couponcode.length > 0) {
        this.isCheckingcode = true;
      } else {
        this.isCheckingcode = false;
      }

      // alert(this.create.couponcode)

      return this.checkCoupon(this.create.couponcode).then(response => {
        this.couponexists = response;
        // console.log(response)
      });
    },
    stopproceed() {
      this.sending = false;
    }
  }
};
</script>

<style scoped>
.list-heads {
  background-color: #00984a;
  color: white;
  border-radius: 5px 5px;
  font-weight: bold;
  display: flex;
  flex-flow: row wrap;
}
.head-p {
  width: 12%;
  padding: 2px;
}
.flex-input-parent {
  display: flex;
}
.left-flex-child {
  width: 95%;
}
.right-flex-child {
  width: 5%;
}
.hidden {
  display: none;
}
.full-width-child {
  width: 100%;
}
.font-green {
  color: green;
}
.errtxt {
  color: red;
}

.image-attachment{
    width: 80px;
    height: 80px;
}
@media screen and (max-width: 999px) {
  .head-p {
    font-size: 0.6rem;
  }
  .page-buttons {
    width: 25px;
    height: 25px;
    padding: 0px 0px 0px 5px;
  }
}
</style>
